module.exports = __webpack_public_path__ + "static/media/calabashHero.95296445.png";